module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Interselect-425386916967187953fd0aa2d765098a.svg";